<template>
  <div class="mypage-ticket-today-page">
    <sub-header-section
      :pageTitle="$tc('MypagePage.MypageTicketTodayPage.title')"
      backLink="/mypage/ticket-list"
    />
    <div class="mypage-ticket-today-page__body">
      <mypage-ticket-today-pane />
    </div>
    <global-navigation-pane :current="'mypage'" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import MypageTicketTodayPane from '@/components/MypageTicketTodayPage/MypageTicketTodayPane.vue'

export default defineComponent({
  name: 'MypageTicketTodayPage',
  components: { MypageTicketTodayPane, GlobalNavigationPane, SubHeaderSection },
})
</script>

<style lang="scss" scoped>
.mypage-ticket-today-page {
  &__body {
    position: relative;
    z-index: 1;
  }
}
</style>
